import React, { Component } from 'react'
import { connect } from 'react-redux'

import { fetchUsers } from '../redux/users'
import LoadingSpinner from './LoadingSpinner'
import Checklist from './Checklist'

class UserChecklist extends Component {
  componentDidMount () {
    const { users, fetchUsers } = this.props
    if (!users) {
      fetchUsers()
    }
  }
  getUserItem = ({ id, name, email }) => {
    const { getExtra } = this.props
    return {
      value: id,
      title: name,
      subtitle: email,
      extra: getExtra && getExtra(id)
    }
  }
  getItems () {
    const { users, getExtra, showExternalUsers, appendToExternal } = this.props
    const items = users.map(this.getUserItem)
    if (showExternalUsers) {
      const external = {
        value: 0,
        title: 'External Users',
        subtitle: this.props.externalSubtitle,
        append: appendToExternal,
        extra: getExtra && getExtra(0)
      }
      return [external].concat(items)
    }
    return items
  }
  render () {
    const { users, value, onChange } = this.props
    if (!users) {
      return <LoadingSpinner />
    }
    return (
      <Checklist
        items={this.getItems()}
        value={value}
        onChange={onChange}
      />
    )
  }
}

const mapStateToProps = ({ users, entities, auth }, { channelUsersOnly }) => ({
  users: users.data && users.data
    .filter(id => id !== auth.user.id)
    .map(id => entities.users[id])
    .filter(user => {
      if (channelUsersOnly) {
        return user.canViewChannels
      }
      return true
    })
})

const mapDispatchToProps = {
  fetchUsers
}

export default connect(mapStateToProps, mapDispatchToProps)(UserChecklist)




// WEBPACK FOOTER //
// ./src/components/UserChecklist.js